import { useContext, useState } from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../../context/context";
import './bots.css';
import logo3d from "../../../assets/images/logo.png";
import {useMediaQuery} from "react-responsive";



function Bots() {

    const {data, isLocal, setModal} = useContext(dataContext);
    const [showItems, setShowItems] = useState(false);

    let urlPrefix = "/images/";
    if (isLocal) urlPrefix = "https://fnxstudio.ru" + urlPrefix;

    const section = data.sectionsdata.find(s => s.nick === 'bots');
    const paragraphs = section ? section.paragraphsdata : [];

    const isMobile = useMediaQuery({ query: "(max-width: 1000px)" });


    return (

            <motion.section
                id="bots"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 0.5, delay: 0.25 }}
                onAnimationComplete={() => {
                    setShowItems(true);
                }}
            >


                    {
                        paragraphs.slice(0, 1).map((par) => (

                            <>

                            <div className="inner_block">

                                <h2><img src={logo3d} alt={section.title} />{section.title}</h2>

                                <h3>{par.title}</h3>
                                {par.text}

                                {
                                    par.ul.length > 0 && (
                                        <>
                                            { par.ul.map((li, index) => (

                                                <p key={index}>{li}</p>

                                            ))
                                            }
                                        </>
                                    )
                                }

                                <button onClick={() => setModal(true)}>Заказать разработку бота</button>

                            </div>

                                {par.galerydata.length > 0  && (

                                    <div className="galery">
                                        <div className="galery_inner">

                                        {
                                            par.galerydata.map((gal, index) => (


                                                <motion.div
                                                    key={index}

                                                    initial={{ opacity: 0, y: 10, scale: 0.5, rotateY: 60, rotateZ: 30 }}
                                                    animate={ showItems ? { opacity: 1, y: 0, scale: 1, rotateY: (isMobile ? 0 : -10), rotateZ:  (isMobile ? 0 : 5) } : {}}
                                                    transition={{ delay: index * 0.3, duration: 0.3 }}
                                                    className="galery_item"
                                                >
                                                    <div className="img" alt="" style={{ backgroundImage: `url(${urlPrefix + gal.image})` }}></div>

                                                    {
                                                        gal.text.map((line, index2) => (
                                                            <span key={index2}>{line}<br /></span>
                                                        ))
                                                    }

                                                </motion.div>

                                            ))
                                        }
                                        </div>
                                    </div>




                                )}

                            </>

                        ))
                    }



            </motion.section>



    )

}

export default Bots;